<template>
  <b-card v-if="!!option" id="page-catalog-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.evolutionInstances.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('company'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('company'))"
                  label-for="company"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="evolutionInstance.guidCompany"
                    input-id="company"
                    :options="listCompanies"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('company'))"
                    :disabled="!isSaveMode"
                    :taggable="false"
                    :reduce="(option) => option.guid"
                    @search="searchCompaniesAll"
                    :filterable="false"
                    @open="onOpenCompanies"
                  >
                    <template #list-footer>
                      <li
                        v-show="hasNextPageCompanies"
                        ref="loadCompanies"
                        class="loader"
                      >
                        Cargando más opciones...
                      </li>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('name'))" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('name'))"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="evolutionInstance.name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('name'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              class="mt-3 d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BAlert,
  BFormSelect,
  BModal,
  BToast,
  BTable,
  BListGroup,
  BListGroupItem,
  BBadge,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import router from "@/router";
import { required, email, confirmed, password } from "@validations";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Ripple from "vue-ripple-directive";

import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import {
  getIntance,
  createOrEditIntance,
  allCompanies,
} from "@/@core/api/request";

const evolutionInstance = {
  id: null,
  guidCompany: null,
  name: null,
};

export default {
  components: {
    FormWizard,
    TabContent,
    BAlert,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BFormSelect,
    BToast,
    BListGroup,
    BListGroupItem,
    BBadge,
    BFormInvalidFeedback,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    isSaveMode: true,
    required,
    dir: "ltr",
    evolutionInstance: Object.assign(evolutionInstance),
    observerCompanies: null,
    listCompanies: [],
    option: null,
    striped: false,
    bordered: false,
    borderless: false,
    outlined: false,
    headVariant: "dark",
    hasNextPageCompanies: true,
    loadingCompanies: false,
    currentPageCompanies: 1,
    perPageCompanies: 30,
    totalPagesClients: null,
  }),

  computed: {},

  created() {
    localize("es");
  },

  mounted() {
    this.evolutionInstance = {
      guidCompany: null,
      name: null,
    };
    this.initialize();
    const observers = [
      { name: "companies", callback: this.infiniteScrollCompanies },
    ];

    observers.forEach((observer) => {
      this[
        `observer${
          observer.name.charAt(0).toUpperCase() + observer.name.slice(1)
        }`
      ] = new IntersectionObserver(observer.callback);
    });
  },
  methods: {
    label(field) {
      return `pages.evolutionInstances.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    initialize() {
      this.option = this.$route.params.option;
      this.loadAllCompanies();
      if (this.option === undefined) {
        router.push({ name: "evolutionIntances" }).catch(() => {});
      }

      if (this.option === 3 || this.option === 2) {
        this.onCancel();
        if (this.$route.params.guid === undefined) {
          router.push({ name: "evolutionIntances" }).catch(() => {});
        }
        this.getInstanceEvolution(this.$route.params.guid);
      } else {
        this.onCancel();
      }
    },

    chargeParamsCompanies() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageCompanies}`);
      arrParams.push(`rows,${this.perPageCompanies}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },

    async loadAllCompanies() {
      if (this.loadingCompanies || !this.hasNextPageCompanies) return;

      this.loadingCompanies = true;
      const param = this.chargeParamsCompanies();
      await allCompanies(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            this.listCompanies = [...this.listCompanies, ...data?.items];
            this.currentPageCompanies = data?.currentPage;
            this.totalPagesCompanies = data?.totalPages || 0;
            this.hasNextPageCompanies =
              this.currentPageCompanies < this.totalPagesCompanies;
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.hasNextPageCompanies = false;
        })
        .finally(() => {
          this.loadingCompanies = false;
        });
    },

    async onOpenCompanies() {
      if (this.hasNextPageCompanies) {
        await this.$nextTick();
        this.observerCompanies.observe(this.$refs.loadCompanies);
      }
    },

    async searchCompaniesAll(value) {
      this.searchClients = value;
      this.listCompanies = [];
      this.currentPageCompanies = 1;
      this.hasNextPageCompanies = true;
      this.loadAllCompanies();
    },

    async infiniteScrollCompanies(values) {
      const value = values[0];

      if (value.isIntersecting) {
        this.currentPageCompanies++;
        await this.loadAllCompanies();
      }
    },

    chargeParams(instanceId) {
      const arrParams = [];

      arrParams.push(`id,${instanceId}`);
      return getParams(arrParams);
    },

    getInstanceEvolution(id) {
      showLoading();
      const param = this.chargeParams(id);
      getIntance(param)
        .then((resp) => {
          stopLoading();
          this.evolutionInstance = Object.assign(this.evolutionInstance, {
            id: resp.data.id || null,
            guidCompany: resp.data.guidCompany || null,
            name: resp.data.name || null,
          });
        })
        .catch((error) => {
          stopLoading();
          this.alertToast("danger", error.message);
        });
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          showLoading();

          const instanceId =
            this.option === 1 ? null : this.evolutionInstance.id;

          createOrEditIntance(this.evolutionInstance, instanceId)
            .then(() => {
              this.alertToast("success", "Registro exitoso");
              this.goBack();
              stopLoading();
            })
            .catch((error) => {
              stopLoading();
              this.alertToast("danger", error.message);
            });
        }
      });
    },

    goBack() {
      this.onCancel();
      this.$refs.simpleRules.reset();
      router.back();
    },

    onCancel() {
      this.catalog = Object.assign({
        guid: null,
        name: null,
        items: [],
      });
    },

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style lang="scss">
.title {
  margin-bottom: 3vh;
}

@import "@core/scss/vue/libs/vue-select.scss";
</style>
